
import React from 'react';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

const ExportTab: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-[#0A1428] rounded-lg p-4 border border-gray-200 dark:border-gray-800 shadow-sm">
        <h4 className="text-sm font-medium mb-3 text-gray-700 dark:text-gray-300">Select Export Format</h4>
        <div className="flex space-x-2">
          <Button variant="outline" size="sm" className="text-xs h-8 bg-white dark:bg-transparent border-gray-300 dark:border-gray-700 text-gray-700 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800">CSV</Button>
          <Button variant="outline" size="sm" className="text-xs h-8 bg-white dark:bg-transparent border-gray-300 dark:border-gray-700 text-gray-700 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800">Excel</Button>
          <Button variant="outline" size="sm" className="text-xs h-8 bg-white dark:bg-transparent border-gray-300 dark:border-gray-700 text-gray-700 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800">PDF</Button>
        </div>
      </div>
      
      <div className="bg-white dark:bg-[#0A1428] rounded-lg p-4 border border-gray-200 dark:border-gray-800 shadow-sm">
        <h4 className="text-sm font-medium mb-3 text-gray-700 dark:text-gray-300">Select Date Range</h4>
        <div className="flex space-x-2">
          <Button variant="outline" size="sm" className="text-xs h-8 bg-white dark:bg-transparent border-gray-300 dark:border-gray-700 text-gray-700 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800">This Month</Button>
          <Button variant="outline" size="sm" className="text-xs h-8 bg-white dark:bg-transparent border-gray-300 dark:border-gray-700 text-gray-700 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800">Last Quarter</Button>
          <Button variant="outline" size="sm" className="text-xs h-8 bg-white dark:bg-transparent border-gray-300 dark:border-gray-700 text-gray-700 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800">YTD</Button>
          <Button variant="outline" size="sm" className="text-xs h-8 bg-white dark:bg-transparent border-gray-300 dark:border-gray-700 text-gray-700 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800">Custom</Button>
        </div>
      </div>
      
      <div className="flex justify-end mt-8">
        <Button className="bg-blue-600 hover:bg-blue-700 text-white shadow-sm">
          <Download className="h-4 w-4 mr-2" />
          Export Data
        </Button>
      </div>
    </div>
  );
};

export default ExportTab;
